/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import styled from "styled-components";

export const ConversationSection = styled.div `
    box-shadow: rgba(0, 0, 0, 0.15) 0 0 8px;
    background-color: $white;

    height: calc(100vh - 80px);
    overflow: hidden;
`;

export const ChatSection = styled.div `
    border-width: 0.0625rem;
    border-style: solid;
    border-color: #e7eaf3;
    
    background-color: $white;

    padding: 10px;

    justify-items: center;

    height: calc(100vh - 80px);
    overflow-x: auto;
`;
